export default __webpack_public_path__ + "static/media/Alimento.f6454a39.png";